<div class="editor-host" [class.editor-error]="hasErrors()">
  <div #host style="height: 100%; width: 100%"></div>
  @if (!ready()) {
    <div class="editor-loading" i18n="@@editor.loading">Loading editor...</div>
  }
</div>

@if (errors().length > 0) {
  <ul
    class="editor-errors"
    role="alert"
    aria-label="JSON parse errors"
    i18n-aria-label="@@editor.errors.aria"
  >
    @for (error of errors(); track error.offset) {
      <li>
        <span class="editor-errors-loc">L{{ error.line }}:{{ error.column }}</span>
        {{ error.message }}
      </li>
    }
  </ul>
}
